'use client';

import { FC, PropsWithChildren } from 'react';
import { ROOT_PORTALS } from 'constants/targets';
import { Portal, Drawer } from 'components/pcc-components';
import { useMyEquipmentDrawer } from '../my-equipment-drawer-context';

export const SelectEquipmentDrawerWrapper: FC<PropsWithChildren> = ({
  children
}) => {
  const {
    selectEquipmentDrawer: { drawerProps, isChild }
  } = useMyEquipmentDrawer();
  const selectEquipmentDrawerProps = {
    ...drawerProps,
    disableBackdropClick: isChild,
    hideCloseButton: isChild
  };

  return (
    <Portal id={ROOT_PORTALS}>
      <Drawer {...selectEquipmentDrawerProps}>{children}</Drawer>
    </Portal>
  );
};
